var React = require('react');

function LayeredStepsHaikeiV2Back (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"backBars","d":"M0 448L75 448L75 396L150 396L150 414L225 414L225 425L300 425L300 395L375 395L375 443L450 443L450 433L525 433L525 403L600 403L600 422L675 422L675 421L750 421L750 428L825 428L825 409L900 409L900 409L900 601L900 601L825 601L825 601L750 601L750 601L675 601L675 601L600 601L600 601L525 601L525 601L450 601L450 601L375 601L375 601L300 601L300 601L225 601L225 601L150 601L150 601L75 601L75 601L0 601Z","fill":"#0066ff"}));
}

LayeredStepsHaikeiV2Back.defaultProps = {"id":"visual","viewBox":"0 0 900 600","version":"1.1"};

module.exports = LayeredStepsHaikeiV2Back;

LayeredStepsHaikeiV2Back.default = LayeredStepsHaikeiV2Back;
